export const MISSING_FIELDS_MESSAGE = 'Required fields not filled.';
export const PIPELINE_MAX_SELECTED_WELLS = 200;
